import React, { Component } from 'react';
import axios from 'axios';
import Select from 'react-select'
import API from '../../../middleware/API';
import swal from 'sweetalert2';
import moment, { weekdays } from 'moment';
import Slider from "react-slick";
import "slick-carousel/slick/slick.css";
import "slick-carousel/slick/slick-theme.css";
import {GetStoreRole, GetStoreDetailRole, yearNames} from '../../../const/constant';
import { Link } from 'react-router-dom';
import FileUploader from '../../FileUploader';

const role = GetStoreRole(localStorage.getItem('current_store_id'));

class FillShift extends Component {
    constructor(props) {
    super(props);
    this.state={
      selectedFile: null,
      shiftPatterns:{},
      jobType: 1,
      jobTypeList: [
        {
          id: 1,
          title: '正常班',
        },{
          id: 2,
          title: '可支援',
        },
        {
          id: 8,
          title: '例假',
        },{
          id: 9,
          title: '休假',
        },        {
          id: 10,
          title: '國定假日排假',
        },
      ],
      //year: moment(new Date()).add(1, 'months').format('Y'),
      year: moment(new Date()).format('Y'),
      //month: moment(new Date()).add(1, 'months').format('M'),
      month: moment(new Date()).format('M'),
      day: '',
      startTime: 0,
      useWeekday: false,
      weekDays:[],

      endTime: 0,
      recentEvent:[
      ],
      employee: '',
      employees:[
      ],
      adminRoleIds:[
        '1','2','5'
      ],
      switchPanel: 1,
      currentPage: 1,
      recordsPerPage: 10,
      keyword: '',
      detailrole :  GetStoreDetailRole(localStorage.getItem('current_store_id')),
      selectedYear: moment().format('YYYY'),
      selectedMonth: moment().format('MM'),
      selectedDept: '內場',
      selectedEventIds: [], // 用於存儲勾選的事件 ID
      loading: false,
    }
    this.fileInputRef = React.createRef(); // 新增 ref
    this.handleCheckboxChange = this.handleCheckboxChange.bind(this);
    this.deleteSelectedEvents = this.deleteSelectedEvents.bind(this);

    this.handleJobTypeChange = this.handleJobTypeChange.bind(this);
    this.handleYearChange = this.handleYearChange.bind(this);
    this.handleMonthChange = this.handleMonthChange.bind(this);
    this.handleDayChange = this.handleDayChange.bind(this);
    this.handleEmployeeChange = this.handleEmployeeChange.bind(this);
    this.handleStartTimeChange = this.handleStartTimeChange.bind(this);
    this.handleEndTimeChange = this.handleEndTimeChange.bind(this);
    this.handleSaveWorkTime = this.handleSaveWorkTime.bind(this);
    this.handleRadioChange = this.handleRadioChange.bind(this);
    this.handleCheckChange = this.handleCheckChange.bind(this);
    this.setSwitchPanel = this.setSwitchPanel.bind(this);
    this.handlePageChange = this.handlePageChange.bind(this);
    this.handleSelectFile = this.handleSelectFile.bind(this);
    this.submitForm = this.submitForm.bind(this);
    this.handleKeywordChange = this.handleKeywordChange.bind(this);
    this.handleYearSelectChange = this.handleYearSelectChange.bind(this);
    this.handleMonthSelectChange = this.handleMonthSelectChange.bind(this);
    this.handleDeptSelectChange = this.handleDeptSelectChange.bind(this);
    this.deleteAllEvents = this.deleteAllEvents.bind(this);

  }
  componentDidMount() {
    this.loadAllData();
  }
  handleSelectFile(event) {
    this.setState({selectedFile: event});
  }
  deleteSelectedEvents() {
    const { selectedEventIds } = this.state;
    if (selectedEventIds.length === 0) {
      swal({
        type: 'warning',
        title: '未選擇任何事件',
        showConfirmButton: false,
        showCloseButton: true,
        heightAuto: false,
      });
      return;
    }
    const eventCount = selectedEventIds.length;
    if(eventCount>50){
      alert('一次最多刪除50筆事件，請分批刪除');
      this.setState({ selectedEventIds: [] });
      return;
    }
    swal({
      title: '確定要刪除選中的'+eventCount+'筆事件嗎？',
      text: "這個動作無法復原！",
      type: 'warning',
      showCancelButton: true,
      confirmButtonColor: '#3085d6',
      cancelButtonColor: '#d33',
      confirmButtonText: '是的，刪除！',
      cancelButtonText: '取消',
    }).then((result) => {
      if (result.value) {
        this.setState({loading:true});
        const ids = selectedEventIds.join(',');
        API.delete(`DeleteRecentEventById?ids=${ids}`).then((res) => {
          this.setState({loading:false});

          if (res) {

            swal({
              type: 'success',
              title: '選中的事件已刪除',
              showConfirmButton: false,
              showCloseButton: true,
              heightAuto: false,
            }).then(() => {
              this.setState({ selectedEventIds: [] , keyword: '', currentPage: 1, loading: true}); // 清空勾選的事件 ID 和關鍵字
              this.loadAllData(); // 刷新數據
            });
          } else {
            swal({
              type: 'error',
              title: '刪除失敗，請聯絡工程師。',
              showConfirmButton: false,
              showCloseButton: true,
              heightAuto: false,
            });
          }
        });
      }
    });
  }
  handleCheckboxChange(eventId) {
    this.setState((prevState) => {
      const { selectedEventIds } = prevState;
      if (selectedEventIds.includes(eventId)) {
        // 如果已經勾選，則取消勾選
        return { selectedEventIds: selectedEventIds.filter((id) => id !== eventId) };
      } else {
        // 如果未勾選，則添加到勾選列表
        return { selectedEventIds: [...selectedEventIds, eventId] };
      }
    });
  }
  submitForm(){
    const formData = new FormData();
    formData.append("File", this.state.selectedFile);
    formData.append("Year", this.state.selectedYear);
    formData.append("Month", this.state.selectedMonth);
    formData.append("Dept", this.state.selectedDept);
    this.setState({loading:true});
    API.post('/ShiftCSV', formData).then((response) => {
      //console.log(response);
      if (response == '1') {
          this.setState({loading:false });

        swal({
          type: 'success',
          title: '上傳成功',
          showConfirmButton: false,
          showCloseButton: true,
          heightAuto: false
        }).then(() => {
          this.setState({ selectedFile: null});
          if (this.fileInputRef.current) {
            this.fileInputRef.current.clear(); // 調用 FileUploader 的 clear 方法
          }
          this.loadAllData();
        });
      }else{
        this.setState({loading:false });
        swal({
          type: 'error',
          title: '資料錯誤，請聯絡工程師。',
          text: response,
          showConfirmButton: false,
          showCloseButton: true,
          heightAuto: false
        })
      }
    });
  };
  handleJobTypeChange(e) {
    this.setState({
      jobType: e.target.value
    })
  }
  handleYearChange(e) {
    this.setState({
      year: e.target.value
    })
  }
  handleMonthChange(e) {
    this.setState({
      month: e.target.value
    })
  }

  handleRadioChange(e) {
    this.setState({
      useWeekday: (e.target.value === "true")? true:false
    })
  }
  handleCheckChange(e){
    const checked = e.target.value;
    if(this.state.weekDays.find(m => m === e.target.value)){
        var newWeekDays = this.state.weekDays;
        newWeekDays.splice(this.state.weekDays.indexOf(e.target.value),1);
        this.setState({
            weekDays: newWeekDays
        })
    }else{
        this.setState(prevState => ({
            weekDays: [...prevState.weekDays, checked]
        }))
    }
  }
  sortNumber(a, b) {
  return a.value - b.value;
  }
  handleDayChange(e) {
    if (e) {
      e.sort(this.sortNumber);
      var dayStr = ''
      for (var i = 0; i < e.length; i++) {
        dayStr = dayStr + e[i].value + ','
      }
      dayStr = dayStr.slice(0, -1);
      this.setState({
        day: dayStr
      })
    }else{
      this.setState({
        day: ''
      })
    }
  }  
  handleEmployeeChange(e) {
    if (e) {
      e.sort(this.sortNumber);
      var employeeIds = ''
      for (var i = 0; i < e.length; i++) {
        employeeIds = employeeIds + e[i].value + ','
      }
      employeeIds = employeeIds.slice(0, -1);
      this.setState({
        employee: employeeIds
      })
    }else{
      this.setState({
        employee: ''
      })
    }
  }  
  handleStartTimeChange(e) {
    this.setState({
      startTime: e.target.value
    })
  }  
  handleEndTimeChange(e) {
    this.setState({
      endTime: e.target.value
    })
  } 
  deleteEvent(e) {
    let index = this.state.recentEvent.indexOf(e);
    var newEvents = this.state.recentEvent.splice(index, 1)
    this.setState({
      recentEvent: this.state.recentEvent
    })
    let objEvent = {
      data: {
        id: `${e.id}`
      }
    }
    API.delete('Event', objEvent).then((res) => {
      if (res) {
      }
    });
  } 
  handleRecordsPerPageChange(e) {
    this.setState({
      recordsPerPage: Number(e.target.value),
      currentPage: 1, // 重置到第一頁
    });
  }
  handleSaveWorkTime(e) {
    if (this.state.adminRoleIds.indexOf(GetStoreRole(localStorage.getItem('current_store_id'))) !== -1) {
      if (this.state.employee.length === 0) {
        swal({
          type: 'error',
          title: '員工未選擇',
          showConfirmButton: false,
          showCloseButton: true,
          heightAuto: false,
          width: '250px'
        });
        return;
      }
    }

    if (this.state.jobType == 0) {
        swal({
        type: 'error',
        title: '班別未選擇',
        showConfirmButton: false,
        showCloseButton: true,
        heightAuto: false,
        width: '250px'
      });
      return;
    }

    if (this.state.day.length == 0 && !this.state.useWeekday) {
        swal({
        type: 'error',
        title: '日期未選擇',
        showConfirmButton: false,
        showCloseButton: true,
        heightAuto: false,
        width: '250px'
      });
      return;
    }

    
    if (this.state.weekDays.length == 0 && this.state.useWeekday) {
      swal({
      type: 'error',
      title: '週間未選擇',
      showConfirmButton: false,
      showCloseButton: true,
      heightAuto: false,
      width: '250px'
    });
    return;
  }
    var startTimeStr = '';
    var endTimeStr = ''
    if(Number(this.state.jobType) !== 8 && Number(this.state.jobType) !== 9 && Number(this.state.jobType) !== 10){
      if (Number(this.state.endTime) == 0 || Number(this.state.startTime) == 0 ) {
        swal({
        type: 'error',
        title: '簽到或簽退時間未選擇',
        showConfirmButton: false,
        showCloseButton: true,
        heightAuto: false,
        width: '250px'
      });
      return;
    }

    if (Number(this.state.endTime) <= Number(this.state.startTime)) {
        swal({
        type: 'error',
        title: '簽退時間不可小於簽到時間',
        showConfirmButton: false,
        showCloseButton: true,
        heightAuto: false,
        width: '250px'
      });
      return;
    }



    if (this.state.startTime.indexOf('.') === -1) {
      if (this.state.startTime > 9) {
        startTimeStr = `${this.state.startTime}:00`
      }else{
        startTimeStr = `0${this.state.startTime}:00`
      }
    }else{
      if (this.state.startTime > 9) {
        startTimeStr = `${Math.floor(this.state.startTime)}:30`
      }else{
        startTimeStr = `0${Math.floor(this.state.startTime)}:30`
      }
    }

    if (this.state.endTime.indexOf('.') === -1) {
      if (this.state.endTime > 9) {
        endTimeStr = `${this.state.endTime}:00`
      }else{
        endTimeStr = `0${this.state.endTime}:00`
      }
    }else{
      if (this.state.endTime > 9) {
        endTimeStr = `${Math.floor(this.state.endTime)}:30`
      }else{
        endTimeStr = `0${Math.floor(this.state.endTime)}:30`
      }
    }
    }
    const typeStr = this.state.jobTypeList.find(m => m.id === Number(this.state.jobType)).title

    let objEvent = {
      Year: this.state.year,
      Month: this.state.month,
      Day: this.state.day,
      ResourceId: this.state.jobType,
      Start: startTimeStr,
      End: endTimeStr,
      useWeekday: this.state.useWeekday,
      WeekDays: this.state.weekDays.join(',')
    }
    if (this.state.employee.length === 0) {
      API.post('MultiEvent', objEvent).then((res) => {
        console.log(res);
        if (res === 1) {
          swal({
            type: 'success',
            title: '新增成功'
          }).then(() => {
            window.location.reload();
          });
        }else{
          if(res === 4){
            swal({
              type: 'error',
              title: '所選日期含有被簽核過的日期',
              showConfirmButton: false,
              showCloseButton: true,
              heightAuto: false,
              width: '250px'
            });
          }else if(res === 5){
            swal({
              type: 'error',
              title: '部分日期含[有假單的排班]故無法新增成功',
              showConfirmButton: false,
              showCloseButton: true,
              heightAuto: false,
              width: '250px'
            });
          }else if(res === -1){
            swal({
              type: 'error',
              title: '所選日期含有已加班事件',
              showConfirmButton: false,
              showCloseButton: true,
              heightAuto: false,
              width: '250px'
            });
          }
        }
      });
    }else{
      objEvent.EmployeeId = this.state.employee
      API.post('Admin/MultiEvent', objEvent).then((res) => {
        console.log(res);
        if (res === 1) {
          swal({
            type: 'success',
            title: '新增成功'
          }).then(() => {
            window.location.reload();
          });
        }else{
          if(res === 4){
            swal({
              type: 'error',
              title: '所選日期含有被簽核過的日期',
              showConfirmButton: false,
              showCloseButton: true,
              heightAuto: false,
              width: '250px'
            });
          }else if(res === 5){
            swal({
              type: 'error',
              title: '部分日期含[有假單的排班]故無法新增成功',
              showConfirmButton: false,
              showCloseButton: true,
              heightAuto: false,
              width: '250px'
            }).then(() => {
              window.location.reload();
            });
          }else if(res === -1){
            swal({
              type: 'error',
              title: '所選日期含有已加班事件',
              showConfirmButton: false,
              showCloseButton: true,
              heightAuto: false,
              width: '250px'
            });
          }else{
            swal({
              type: 'error',
              title: '下列日期有'+typeStr+'事件導致新增失敗',
              html: `<ul>${res.split(',').map(date => `<li style='list-style:none'>${date.trim()}</li>`).join('')}</ul>`,
              showConfirmButton: false,
              showCloseButton: true,
              heightAuto: false,
              width: '250px'
            });
          }
        }
      });
    }

  }
  loadAllData() {
    // API.get('RecentEvent').then((res) => {
    //   if (res) {
    //     this.setState({
    //       recentEvent: res
    //     })
    //   }
    // });
    // API.get('ShiftPattern').then((res) => {
    //   if (res) {
    //     this.setState({
    //       shiftPatterns: res
    //     })
    //   }
    // });
    // API.get('User/All').then((res) => {
    //   if (res) {
    //     this.setState({
    //       employees: res
    //     })
    //   }
    // });
            axios.all([
          API.get('RecentEvent'),
          API.get('ShiftPattern'),
          API.get('User/All')
        ])
          .then(axios.spread((recentEvent, shiftPatterns, employees) => {
            this.setState({
              recentEvent: recentEvent,
              shiftPatterns: shiftPatterns,
              employees: employees,
              loading:false
            })     
        }));
  }
  deleteAllEvents() {
    const { keyword, ShiftPattern } = this.state;
    const query = keyword ? `?keyword=${keyword}` : '';
    
    swal({
      title: keyword ?'確定要刪除所有'+keyword+'嗎？':'確定要刪除近期所有嗎？',
      text: "這個動作無法復原！",
      type: 'warning',
      showCancelButton: true,
      confirmButtonColor: '#3085d6',
      cancelButtonColor: '#d33',
      confirmButtonText: '是的，刪除！',
      cancelButtonText: '取消'
    }).then((result) => {
      if (result.value) {
        API.delete(`DeleteRecentEvent${query}`).then((res) => {
          console.log(res)
          if (res) {
            swal({
              type: 'success',
              title: '所有'+keyword+'紀錄已刪除',
              showConfirmButton: false,
              showCloseButton: true,
              heightAuto: false
            }).then((result) => {
              this.setState(
                {
                  keyword: ''
                },
                () => {
                  this.loadAllData(); // 在 setState 完成後執行
                }
              );
            })
          
          } else {
            swal({
              type: 'error',
              title: '刪除失敗，請聯絡工程師。',
              showConfirmButton: false,
              showCloseButton: true,
              heightAuto: false
            });
          }
        });
      }
    });
  }

  handleSelectFile(file) {
    swal({
      title: `即將上傳${this.state.selectedYear} 年 ${this.state.selectedMonth} 月${this.state.selectedDept}排班表`,
      text: `請確認檔案月份與下拉選單月份 (${this.state.selectedYear} 年 ${this.state.selectedMonth} 月${this.state.selectedDept}) 是否一致！`,
      type: 'warning',
      showCancelButton: true,
      confirmButtonText: '確認',
      cancelButtonText: '取消',
    }).then((result) => {
      console.log(result);
      
      if (result.value) {
        // 如果使用者確認，則保留文件
        console.log('保留文件');
        
        this.setState({ selectedFile: file });
      } else {
        // 如果使用者取消，清空文件選擇
        console.log('清空文件');

        this.setState({ selectedFile: null });
        if (this.fileInputRef.current) {
          this.fileInputRef.current.clear(); // 調用 FileUploader 的 clear 方法
        }
      }
    });
  }
  setSwitchPanel(panel) {
    this.setState({ switchPanel: panel });
  }
  handlePageChange(event) {
    this.setState({ currentPage: Number(event.target.id) });
  }
  handleKeywordChange(e) {
    this.setState({ keyword: e.target.value, currentPage: 1 });
  }
  handleYearSelectChange(e) {
    this.setState({ selectedYear: e.target.value });
  }

  handleMonthSelectChange(e) {
    this.setState({ selectedMonth: e.target.value });
  }
  handleDeptSelectChange(e) {
    this.setState({ selectedDept: e.target.value });
  }
  render() {

  if (this.state.loading) {
    return (
      <div className="loading__overlay">
        <div className="loading__content">
          <div className="spinner" />
          <h1>資料處理中</h1>
        </div>
      </div>
    );
  }
    let employeeList = [];
    for (var i = 0 ; i < this.state.employees.length ; i++) {
      employeeList.push({value: this.state.employees[i].id, label: this.state.employees[i].realName})
    }
    let dayList = [];
    for (var i = 1 ; i < 32 ; i++) {
      dayList.push({value: i, label: i})
    }
    let monthList = [];
    for (var i = 1 ; i < 13 ; i++) {
      monthList.push(<option key={i} value={i}>{ i }</option>)
    }
    let timeList = [];
    for (var i = 1 ; i < 19 ; i++) {
      if (i+5>9) {
        timeList.push(<option key={`${i+5}00`} value={`${i+5}`}>{`${i+5}:00`}</option>)
        timeList.push(<option key={`${i+5}30`} value={`${i+5.5}`}>{`${i+5}:30`}</option>)
      }else{
        timeList.push(<option key={`${i+5}00`} value={`${i+5}`}>{`0${i+5}:00`}</option>)
        timeList.push(<option key={`${i+5}30`} value={`${i+5.5}`}>{`0${i+5}:30`}</option>)
      }
    }
    var settings = {
      dots: true,
    };
    let recentEventList = [];
    for (var i = 1 ; i < this.state.recentEvent.length ; i++) {
      recentEventList.push(
        <div key={this.state.recentEvent[i].id}>
        <p>{ this.state.recentEvent[i].start }</p>
        <p>{ this.state.recentEvent[i].end }</p>
        <p>{ this.state.recentEvent[i].title }</p>
        </div>
        )
    }
    const shiftPatterns = this.state.shiftPatterns;
    const hasEvent = this.state.recentEvent.length > 0
    const isAdmin = this.state.adminRoleIds.indexOf(GetStoreRole(localStorage.getItem('current_store_id'))) !== -1
    const { switchPanel, currentPage, recordsPerPage, keyword } = this.state;
    const filteredRecords = this.state.recentEvent.filter(event =>
      event.title.toLowerCase().includes(keyword.toLowerCase())
    );
    const indexOfLastRecord = currentPage * recordsPerPage;
    const indexOfFirstRecord = indexOfLastRecord - recordsPerPage;
    const currentRecords = filteredRecords.slice(indexOfFirstRecord, indexOfLastRecord);
    // const pageNumbers = [];
    // for (let i = 1; i <= Math.ceil(filteredRecords.length / recordsPerPage); i++) {
    //   pageNumbers.push(i);
    // }
    // const renderPageNumbers = pageNumbers.map(number => (
    //   <button disabled={currentPage === number} key={number} id={number} onClick={this.handlePageChange} className={currentPage === number ? 'active' : ''}>
    //     {number}
    //   </button>
    // ));

    const pageNumbers = [];
for (let i = 1; i <= Math.ceil(filteredRecords.length / recordsPerPage); i++) {
  pageNumbers.push(i);
}

const renderPageNumbers = pageNumbers.map((number) => (
  <button
    disabled={currentPage === number}
    key={number}
    id={number}
    onClick={this.handlePageChange}
    className={currentPage === number ? 'active' : ''}
  >
    {number}
  </button>
));
    return (
      <div className="fill-shift">
          <div className="row">
            <div className="col-6 col-pad-12">
            <Link className="btn btn-md save" style={{color:'white'}} to={{ pathname: "https://drive.google.com/file/d/1OzPR7yVrh5n0pAYiGSCdcBbKX2a9yaDS/view?usp=drive_link" }} target="_blank">員工手冊</Link>
          
            </div>

          </div>
          <div className="u-tag_group">
            <a className={switchPanel === 1 ? 'tag active' : 'tag'} onClick={() => { this.setSwitchPanel(1); }} >填班表</a>
            <a className={switchPanel === 2 ? 'tag active' : 'tag'} onClick={() => { this.setSwitchPanel(2); }} >近期新增紀錄</a>
            <a className={switchPanel === 3 ? 'tag active' : 'tag'} onClick={() => { this.setSwitchPanel(3); }} >班別管理</a>

          </div>
          {switchPanel === 3 && (
          <div className="row">
            
            <div className="col-6 col-pad-12">
              <div className="u-block" style={{textAlign: 'center', paddingBottom: '30px'}}>
                <button
                      className='btn btn-md edit'
                      onClick={() => {
                      swal.fire({
                        title: '新增內場班別',
                        html: `
                          <div style="margin-bottom:10px;">
                            <label>班別名稱：</label>
                            <input id="swal-input-name" class="swal2-input" type="text" placeholder="請輸入班別名稱" />
                          </div>
                          <div style="margin-bottom:10px;">
                            <label>上班時間：</label>
                            <input id="swal-input-start" class="swal2-input" type="time" step="1800" value="09:00" />
                          </div>
                          <div style="margin-bottom:10px;">
                            <label>下班時間：</label>
                            <input id="swal-input-end" class="swal2-input" type="time" step="1800" value="20:00" />
                          </div>
                        `,
                        focusConfirm: false,
                        showCancelButton: true,
                        confirmButtonText: '確認',
                        cancelButtonText: '取消',
                        preConfirm: () => {
                          const name = document.getElementById('swal-input-name').value.trim();
                          const startAt = document.getElementById('swal-input-start').value;
                          const endAt = document.getElementById('swal-input-end').value;
                          const dept = '內場';

                          if (!name || !startAt || !endAt || !dept) {
                            swal.showValidationMessage('請輸入完整資訊');
                            return false;
                          }

                          // 檢查下班時間必須大於上班時間
                          const parseTime = (t) => {
                            const [h, m] = t.split(':').map(Number);
                            return h * 60 + m;
                          };
                          if (parseTime(endAt) <= parseTime(startAt)) {
                            swal.showValidationMessage('下班時間必須大於上班時間');
                            return false;
                          }

                          // 補齊時間格式為 HH:mm:ss
                          const padTime = (timeStr) => {
                            if (!timeStr) return '';
                            if (/^\d{2}:\d{2}:\d{2}$/.test(timeStr)) return timeStr;
                            if (/^\d{2}:\d{2}$/.test(timeStr)) return timeStr + ':00';
                            return timeStr;
                          };
                          return {
                            Name: name,
                            StartAt: padTime(startAt),
                            EndAt: padTime(endAt),
                            Dept: dept
                          };
                        }
                      }).then(result => {
                        if (result.value) {
                          API.post('ShiftPattern', result.value).then(res => {
                            if (res) {
                              swal.fire({
                                type: 'success',
                                title: '新增成功',
                                showConfirmButton: false,
                                timer: 1000
                              });
                              this.loadAllData();
                            } else {
                              swal.fire({
                                type: 'error',
                                title: '新增失敗，請聯絡工程師。',
                                showConfirmButton: false,
                                timer: 1500
                              });
                            }
                          });
                        }
                      });
                      }}
                    >
                      新增內場班別
                    </button>
                  <div name='tool-bar' style={{display:this.state.detailrole === '38' || this.state.detailrole === '3' ||localStorage.getItem("username") === "22"?'flex':'none', justifyContent: 'space-between'}}>
                 
              </div>
                <div className="u-small-title">內場班別管理</div>
                {
                  shiftPatterns.infieldShiftPatterns ? (
                    <div>
                      <table>
                        <thead>
                          <tr style={{height: '43px'}}>
                            <th>班別</th>
                            <th>上班時間</th>
                            <th>下班時間</th>
                            <th>操作</th>
                          </tr>
                        </thead>
                        <tbody>
                          {
                            shiftPatterns.infieldShiftPatterns.map(event => (
                              <tr key={event.id}>
                                <td>{ event.name }</td>
                                <td>{ event.startAt }</td>
                                <td>{ event.endAt }</td>
                                <td>
                              <button
                              type="button"
                              className="btn btn-md save"
                              onClick={() => {
                                swal.fire({
                                title: `編輯班別：${event.name}`,
                                html: `
                                  <div style="margin-bottom:10px;">
                                  <label>上班時間：</label>
                                  <input id="swal-input1" class="swal2-input" type="time" value="${event.startAt}" />
                                  </div>
                                  <div>
                                  <label>下班時間：</label>
                                  <input id="swal-input2" class="swal2-input" type="time" value="${event.endAt}" />
                                  </div>
                                `,
                                focusConfirm: false,
                                showCancelButton: true,
                                confirmButtonText: '確認',
                                cancelButtonText: '取消',
                                preConfirm: () => {
                                  const startAt = document.getElementById('swal-input1').value;
                                  const endAt = document.getElementById('swal-input2').value;
                                  if (!startAt || !endAt) {
                                  swal.showValidationMessage('請輸入完整時間');
                                  return false;
                                  }
                                  return { startAt, endAt };
                                }
                                }).then(result => {
                                  console.log(result);
                                if (result.value) {
                                    // 補齊時間格式為 HH:mm:ss
                                    const padTime = (timeStr) => {
                                    if (!timeStr) return '';
                                    // 若已經有秒數，直接回傳
                                    if (/^\d{2}:\d{2}:\d{2}$/.test(timeStr)) return timeStr;
                                    // 若只有 HH:mm，補 :00
                                    if (/^\d{2}:\d{2}$/.test(timeStr)) return timeStr + ':00';
                                    return timeStr;
                                    };
                                    API.post(`ShiftPattern/${event.id}`, {
                                    StartAt: padTime(result.value.startAt),
                                    EndAt: padTime(result.value.endAt),
                                    Name: event.name,
                                    }).then(res => {
                                  if (res) {
                                    swal.fire({
                                    type: 'success',
                                    title: '修改成功',
                                    showConfirmButton: false,
                                    timer: 1000
                                    });
                                    this.loadAllData();
                                  } else {
                                    swal.fire({
                                    type: 'error',
                                    title: '修改失敗，請聯絡工程師。',
                                    showConfirmButton: false,
                                    timer: 1500
                                    });
                                  }
                                  });
                                }
                                });
                              }}
                              >編輯</button>
                              <button
                                type="button"
                                className="btn btn-md edit"
                                style={{ backgroundColor: 'red', marginLeft: '8px' }}
                                onClick={() => {
                                  swal.fire({
                                    title: `確定要刪除班別：${event.name}？`,
                                    text: "這個動作無法復原！",
                                    type: 'warning',
                                    showCancelButton: true,
                                    confirmButtonColor: '#d33',
                                    cancelButtonColor: '#3085d6',
                                    confirmButtonText: '是的，刪除！',
                                    cancelButtonText: '取消'
                                  }).then(result => {
                                    if (result.value) {
                                      API.delete(`ShiftPattern/${event.id}`).then(res => {
                                        if (res) {
                                          swal.fire({
                                            type: 'success',
                                            title: '刪除成功',
                                            showConfirmButton: false,
                                            timer: 1000
                                          });
                                          this.loadAllData();
                                        } else {
                                          swal.fire({
                                            type: 'error',
                                            title: '刪除失敗，請聯絡工程師。',
                                            showConfirmButton: false,
                                            timer: 1500
                                          });
                                        }
                                      });
                                    }
                                  });
                                }}
                              >
                                刪除
                              </button>
                            </td>
                              </tr>
                            ))
                          }
                        </tbody>
                      </table>
                      <div className="pagination">
                        {renderPageNumbers}
                      </div>
                    </div>
                  ) : (
                    <h4>無紀錄</h4>
                  )
                }
              </div>
            </div>          
          <div className="col-6 col-pad-12">
              <div className="u-block" style={{textAlign: 'center', paddingBottom: '30px'}}>
                <button
                      className='btn btn-md edit'
                      onClick={() => {
                        swal.fire({
                        title: '新增外場班別',
                        html: `
                        <div style="margin-bottom:10px;">
                          <label>班別名稱：</label>
                          <input id="swal-input-name" class="swal2-input" type="text" placeholder="請輸入班別名稱" />
                        </div>
                          <div style="margin-bottom:10px;">
                            <label>上班時間：</label>
                            <input id="swal-input-start" class="swal2-input" type="time" step="1800" value="09:00" />
                          </div>
                          <div style="margin-bottom:10px;">
                            <label>下班時間：</label>
                            <input id="swal-input-end" class="swal2-input" type="time" step="1800" value="20:00" />
                          </div>
                        `,
                        focusConfirm: false,
                        showCancelButton: true,
                        confirmButtonText: '確認',
                        cancelButtonText: '取消',
                        preConfirm: () => {
                        const name = document.getElementById('swal-input-name').value.trim();
                        const startAt = document.getElementById('swal-input-start').value;
                        const endAt = document.getElementById('swal-input-end').value;
                        const dept = '外場';
                        if (!name || !startAt || !endAt || !dept) {
                          swal.showValidationMessage('請輸入完整資訊');
                          return false;
                        }
                          // 檢查下班時間必須大於上班時間
                          const parseTime = (t) => {
                            const [h, m] = t.split(':').map(Number);
                            return h * 60 + m;
                          };
                          if (parseTime(endAt) <= parseTime(startAt)) {
                            swal.showValidationMessage('下班時間必須大於上班時間');
                            return false;
                          }
                        // 補齊時間格式為 HH:mm:ss
                        const padTime = (timeStr) => {
                          if (!timeStr) return '';
                          if (/^\d{2}:\d{2}:\d{2}$/.test(timeStr)) return timeStr;
                          if (/^\d{2}:\d{2}$/.test(timeStr)) return timeStr + ':00';
                          return timeStr;
                        };
                        return {
                          Name: name,
                          StartAt: padTime(startAt),
                          EndAt: padTime(endAt),
                          Dept: dept
                        };
                        }
                        }).then(result => {
                        if (result.value) {
                        API.post('ShiftPattern', result.value).then(res => {
                          if (res) {
                          swal.fire({
                          type: 'success',
                          title: '新增成功',
                          showConfirmButton: false,
                          timer: 1000
                          });
                          this.loadAllData();
                          } else {
                          swal.fire({
                          type: 'error',
                          title: '新增失敗，請聯絡工程師。',
                          showConfirmButton: false,
                          timer: 1500
                          });
                          }
                        });
                        }
                        });
                      }}
                    >
                      新增外場班別
                    </button>
                <div className="u-small-title">外場班別管理</div>
                {
                  shiftPatterns.outfieldShiftPatterns ? (
                    <div>
                      <table>
                        <thead>
                          <tr style={{height: '43px'}}>
                            <th>班別</th>
                            <th>上班時間</th>
                            <th>下班時間</th>
                            <th>操作</th>
                          </tr>
                        </thead>
                        <tbody>
                          {
                            shiftPatterns.outfieldShiftPatterns.map(event => (
                              <tr key={event.id}>
                                <td>{ event.name }</td>
                                <td>{ event.startAt }</td>
                                <td>{ event.endAt }</td>
                                <td>
                              <button
                              type="button"
                              className="btn btn-md save"
                              onClick={() => {
                                swal.fire({
                                title: `編輯班別：${event.name}`,
                                html: `
                                  <div style="margin-bottom:10px;">
                                  <label>上班時間：</label>
                                  <input id="swal-input1" class="swal2-input" type="time" value="${event.startAt}" />
                                  </div>
                                  <div>
                                  <label>下班時間：</label>
                                  <input id="swal-input2" class="swal2-input" type="time" value="${event.endAt}" />
                                  </div>
                                `,
                                focusConfirm: false,
                                showCancelButton: true,
                                confirmButtonText: '確認',
                                cancelButtonText: '取消',
                                preConfirm: () => {
                                  const startAt = document.getElementById('swal-input1').value;
                                  const endAt = document.getElementById('swal-input2').value;
                                  if (!startAt || !endAt) {
                                  swal.showValidationMessage('請輸入完整時間');
                                  return false;
                                  }
                                  return { startAt, endAt };
                                }
                                }).then(result => {
                                  console.log(result);
                                if (result.value) {
                                    // 補齊時間格式為 HH:mm:ss
                                    const padTime = (timeStr) => {
                                    if (!timeStr) return '';
                                    // 若已經有秒數，直接回傳
                                    if (/^\d{2}:\d{2}:\d{2}$/.test(timeStr)) return timeStr;
                                    // 若只有 HH:mm，補 :00
                                    if (/^\d{2}:\d{2}$/.test(timeStr)) return timeStr + ':00';
                                    return timeStr;
                                    };
                                    API.post(`ShiftPattern/${event.id}`, {
                                    StartAt: padTime(result.value.startAt),
                                    EndAt: padTime(result.value.endAt),
                                    Name: event.name,
                                    }).then(res => {
                                  if (res) {
                                    swal.fire({
                                    type: 'success',
                                    title: '修改成功',
                                    showConfirmButton: false,
                                    timer: 1000
                                    });
                                    this.loadAllData();
                                  } else {
                                    swal.fire({
                                    type: 'error',
                                    title: '修改失敗，請聯絡工程師。',
                                    showConfirmButton: false,
                                    timer: 1500
                                    });
                                  }
                                  });
                                }
                                });
                              }}
                              >編輯</button>
                                                            <button
                                type="button"
                                className="btn btn-md edit"
                                style={{ backgroundColor: 'red', marginLeft: '8px' }}
                                onClick={() => {
                                  swal.fire({
                                    title: `確定要刪除班別：${event.name}？`,
                                    text: "這個動作無法復原！",
                                    type: 'warning',
                                    showCancelButton: true,
                                    confirmButtonColor: '#d33',
                                    cancelButtonColor: '#3085d6',
                                    confirmButtonText: '是的，刪除！',
                                    cancelButtonText: '取消'
                                  }).then(result => {
                                    if (result.value) {
                                      API.delete(`ShiftPattern/${event.id}`).then(res => {
                                        if (res) {
                                          swal.fire({
                                            type: 'success',
                                            title: '刪除成功',
                                            showConfirmButton: false,
                                            timer: 1000
                                          });
                                          this.loadAllData();
                                        } else {
                                          swal.fire({
                                            type: 'error',
                                            title: '刪除失敗，請聯絡工程師。',
                                            showConfirmButton: false,
                                            timer: 1500
                                          });
                                        }
                                      });
                                    }
                                  });
                                }}
                              >
                                刪除
                              </button>
                            </td>
                              </tr>
                            ))
                          }
                        </tbody>
                      </table>
                      <div className="pagination">
                        {renderPageNumbers}
                      </div>
                    </div>
                  ) : (
                    <h4>無紀錄</h4>
                  )
                }
              </div>
            </div> 
          </div>
          )}
          {switchPanel === 2 && (
            <div className="u-block" style={{textAlign: 'center', paddingBottom: '30px'}}>
              <div name='tool-bar' style={{display:this.state.detailrole === '38' || this.state.detailrole === '3' ||localStorage.getItem("username") === "22"?'flex':'none', justifyContent: 'space-between'}}>
                  <form style={{display: 'flex', justifyContent: 'space-between', backgroundColor: '#f0f0f0', border: '1px solid black', padding: '10px', flex: 1, marginRight: '10px'}}>

                  <FileUploader
                            ref={this.fileInputRef} // 綁定 ref
  onFileSelectSuccess={this.handleSelectFile}
  onFileSelectError={({ error }) => alert(error)}
/>
                  <select value={this.state.selectedYear} onChange={this.handleYearSelectChange}>
                    <option value={moment().format('YYYY')}>{moment().format('YYYY')}</option>
                    <option value={moment().add(1, 'year').format('YYYY')}>{moment().add(1, 'year').format('YYYY')}</option>
                  </select>
                  <select value={this.state.selectedMonth} onChange={this.handleMonthSelectChange}>
                    {Array.from({ length: 12 }, (_, i) => (
                      <option key={i + 1} value={String(i + 1).padStart(2, '0')}>
                        {String(i + 1).padStart(2, '0')}
                      </option>
                    ))}
                  </select>
                  <select value={this.state.selectedDept} onChange={this.handleDeptSelectChange}>
                    <option value="內場">內場</option>
                    <option value="外場">外場</option>
                    <option value="吧檯">吧檯</option>
                  </select>
                  <button  style={{display: 'flex', justifyContent: 'space-between'}} type='button' onClick={this.submitForm} disabled={!this.state.selectedFile}>上傳</button>


                </form>
                <div style={{backgroundColor: '#f0f0f0', border: '1px solid black', padding: '10px', flex: 1}}>
                  <input
                    type="text"
                    placeholder="過濾員工姓名"
                    value={keyword}
                    onChange={this.handleKeywordChange}
                    style={{width: '100%'}}
                  />
                </div>
                <button style={{backgroundColor: 'red', color: 'white', marginLeft: '10px'}} onClick={this.deleteSelectedEvents}>
                  {'刪除勾選'}
                </button>
              </div>
              <div className="sign-notice" style={{height:'30px'}}>
               <div className="u-notice" style={{float:'left',textAlign:'left', paddingBottom:'5px'}}>
                
                (1)刪除事件時若同時有正常班與調整後正常班請一併刪除。<br/>
                (2)若勾選框呈現淺灰色無法勾選表示該事件有加班單或假單。
               </div>
               
        </div>
              <div className="u-small-title">近期新增紀錄</div>

              {
                hasEvent ? (
                  <div>
                    <div name="tool-bar" style={{ display: 'flex', justifyContent: 'space-between', marginBottom: '10px' }}>
  <div style={{ flex: 1 }}>
  <div>
    已勾選：<span style={{color:'red'}}>{this.state.selectedEventIds.length}</span> 筆排班
  </div>
    <label htmlFor="recordsPerPage">每頁顯示筆數：</label>
    <select
      id="recordsPerPage"
      value={this.state.recordsPerPage}
      onChange={(e) => this.handleRecordsPerPageChange(e)}
      style={{ marginLeft: '10px' }}
    >
      <option value="10">10</option>
      <option value="50">50</option>
    </select>
  </div>

</div>
                    <table>
                      <thead>
                        <tr style={{height: '43px'}}>
                        <th>
                        <input
                        className='checkmark'
  type="checkbox"
  onChange={(e) => {
    const isChecked = e.target.checked;
    if (isChecked) {
      // 全選當前頁面的項目
      const newSelectedIds = currentRecords
        .map((event) => event.id)
        .filter((id) => !this.state.selectedEventIds.includes(id)); // 避免重複添加
      this.setState((prevState) => ({
        selectedEventIds: [...prevState.selectedEventIds, ...newSelectedIds],
      }));
    } else {
      // 全不選當前頁面的項目
      const deselectedIds = currentRecords.map((event) => event.id);
      this.setState((prevState) => ({
        selectedEventIds: prevState.selectedEventIds.filter((id) => !deselectedIds.includes(id)),
      }));
    }
  }}
  checked={
    currentRecords.length > 0 &&
    currentRecords.every((event) => this.state.selectedEventIds.includes(event.id))
  }
/>
                          </th>
                          <th>班別</th>
                          <th>上班時間</th>
                          <th>下班時間</th>
                          <th>備註</th>
                          <th>操作</th>
                          <th>新增時間</th>

                        </tr>
                      </thead>
                      <tbody>
                        {
                          currentRecords.map(event => (
                            <tr key={event.id}
                            onClick={() => this.handleCheckboxChange(event.id)} style={{ cursor: 'pointer' }}>
                              <td>
                                <input
                                  className='checkmark'
                                  type="checkbox"
                                  onClick={(e) => {
                                            e.stopPropagation(); // Prevents the click from reaching the <tr>
                                            this.handleCheckboxChange(event.id); // Toggles the selection
                                          }}
                                  checked={this.state.selectedEventIds.includes(event.id)}
                                  disabled={event.hasLeaveRec || event.hasOverRec}
                                  />
                              </td>
                              <td>{ event.title }</td>
                              <td>{ event.start.replace('T',' ') }</td>
                              <td>{ event.end.replace('T',' ') }</td>
                              <td>{ event.hasLeaveRec ? '此筆排班含有假單' : '' }</td>
                              <td><button type="button" className="btn btn-md save" style={{backgroundColor: 'red'}} onClick={() => this.deleteEvent(event)}>刪除</button></td>
                              <td>{ event.createAt.split(':').slice(0, 2).join(':').replace('T',' ')}</td>
                              </tr>
                          ))
                        }
                      </tbody>
                    </table>
                    <div className="pagination">
                      {renderPageNumbers}
                    </div>
                  </div>
                ) : (
                  <h4>無紀錄</h4>
                )
              }
            </div>
          )}
          {switchPanel === 1 && (
            <div className="u-block">
              <div className="u-small-title">填班表</div>
              <form className="u-form">
                {
                  isAdmin && (
                    <div className="row">
                      <div className="col-12 col-pad-12">
                        <div style={{width: '50%', textAlign:'center'}}>
                          <label className="u-form__label text-align-center" style={{width: '28%'}}>員工：</label>
                        </div>
                        <div style={{width: '50%'}} >
                          <Select options={employeeList} isMulti className="basic-multi-select"
                          placeholder="請選擇"
                          onChange={this.handleEmployeeChange}
                          />
                        </div>
                      </div>
                    </div>
                  )
                }
                <div className="row">
                  <div className="col-12 col-pad-12">
                    <div style={{width: '50%', textAlign:'center'}}>
                      <label className="u-form__label text-align-center" style={{width: '28%'}}>班別：</label>
                    </div>
                    <div style={{width: '50%'}} >
                      <select value={Number(this.state.jobType)} className="u-form__select" 
                        onChange={this.handleJobTypeChange}
                      >
                        <option value="0" disabled>請選擇</option>
                        {
                          this.state.jobTypeList.map(jobType => (
                            <option key={jobType.id} value={jobType.id}>{ jobType.title }</option>
                          ))
                        }
                      </select>
                    </div>
                  </div>
                </div>
                  <div className="row">
                  <div className="col-12 col-pad-12">
                    <div style={{width: '50%', textAlign:'center'}}>
                      <label className="u-form__label text-align-center" style={{width: '28%'}}>年：</label>
                    </div>
                    <div style={{width: '50%'}}>
                      <select value={Number(this.state.year)} className="u-form__select" 
                        onChange={this.handleYearChange}
                        style={{width: '100%'}}
                      >
                        <option value="0" disabled>請選擇</option>
                        {
                          yearNames.map(yearName => (
                            <option key={yearName} value={yearName}>{ yearName }</option>
                          ))
                        }

                      </select>
                    </div>

                  </div>
                </div>
                <div className="row">
                  <div className="col-12 col-pad-12">
                    <div style={{width: '50%', textAlign:'center'}}>
                      <label className="u-form__label text-align-center" style={{width: '28%'}}>上班月：</label>
                    </div>
                    <div style={{width: '50%'}}>
                      <select value={Number(this.state.month)} className="u-form__select" 
                        onChange={this.handleMonthChange}
                      >
                        <option value="0" disabled>請選擇</option>
                        {
                          monthList
                        }
                      </select>                
                    </div>
                  </div>
                </div>
                
                <div className="row">
                    <div className="col-12 col-pad-12">
                    <div style={{width: '50%', textAlign:'center'}}>
                      <label className="u-form__label text-align-center" style={{width: '28%'}}>填班方式：</label>
                    </div>
                    <div className="col-3 col-pad-3">
                    <label className="u-form__label text-align-right" style={{flex: '0 0 54px'}}>
                          <input
                            type="radio"
                            value="false"
                            checked={!this.state.useWeekday}
                            onChange={(e)=>{this.handleRadioChange(e);}}
                            />                                
                          日期
                          </label>
                      </div>

                    
                    <div className="col-3 col-pad-3">
                        <label className="u-form__label text-align-right">
                        <input
                        type="radio"
                        value="true"
                        checked={this.state.useWeekday}
                        onChange={(e)=>{this.handleRadioChange(e);}}
                        /> 
                        週間</label>
                    </div>
                    </div>
                </div>
                <div className="row" style={{display:this.state.useWeekday?'none':'block'}}>
                  <div className="col-12 col-pad-12">
                    <div style={{width: '50%', textAlign:'center'}}>
                      <label className="u-form__label text-align-center" style={{width: '28%'}}>預期上班日：</label>
                    </div>
                    <div style={{width: '50%'}} >
                      <Select options={dayList} isMulti className="basic-multi-select"
                      placeholder="請選擇"
                      onChange={this.handleDayChange}
                        />
                    </div> 


                  </div>
                </div>
                <div className="row" style={{display:this.state.useWeekday?'block':'none'}}>
                  <div className="col-12 col-pad-12">
                    <div style={{width: '50%', textAlign:'center'}}>
                      <label className="u-form__label text-align-center" style={{width: '28%'}}>預期上班週間：</label>
                    </div>
                    <div style={{width: '50%'}} >
                    <label >
                        <input style={{transform:'scale(1.5)'}} key={1} onClick={this.handleCheckChange} type="checkbox" defaultChecked={this.state.isMonCheck} value={1} /> <span style={{fontSize:'18px'}}>禮拜一</span> <br/>
                    </label>
                    <label>
                        <input style={{transform:'scale(1.5)'}} key={2} onClick={this.handleCheckChange} type="checkbox" defaultChecked={this.state.isTueCheck} value={2} /> <span style={{fontSize:'18px'}}>禮拜二</span> <br/>
                    </label>
                    <label>
                        <input style={{transform:'scale(1.5)'}} key={3} onClick={this.handleCheckChange} type="checkbox" defaultChecked={this.state.isWedCheck} value={3} /> <span style={{fontSize:'18px'}}>禮拜三</span> <br/>
                    </label>
                    <label>
                        <input style={{transform:'scale(1.5)'}} key={4} onClick={this.handleCheckChange} type="checkbox" defaultChecked={this.state.isThuCheck} value={4} /> <span style={{fontSize:'18px'}}>禮拜四</span> <br/>
                    </label>
                    <label>
                        <input style={{transform:'scale(1.5)'}} key={5} onClick={this.handleCheckChange} type="checkbox" defaultChecked={this.state.isFriCheck} value={5} /> <span style={{fontSize:'18px'}}>禮拜五</span> <br/>
                    </label>
                    <label>
                        <input style={{transform:'scale(1.5)'}} key={6} onClick={this.handleCheckChange} type="checkbox" defaultChecked={this.state.isSatCheck} value={6} /> <span style={{fontSize:'18px'}}>禮拜六</span> <br/>
                    </label>
                    <label>
                        <input style={{transform:'scale(1.5)'}} key={0} onClick={this.handleCheckChange} type="checkbox" defaultChecked={this.state.isSunCheck} value={0} /> <span style={{fontSize:'18px'}}>禮拜日</span> 
                    </label>

                    </div>
                  </div>
                </div>  
                {
                  Number(this.state.jobType) !== 8 && Number(this.state.jobType) !== 9&& Number(this.state.jobType) !== 10 ? 
                  <div className="row">
                    <div className="col-12 col-pad-12">
                      <div style={{width: '50%', textAlign:'center'}}>
                        <label className="u-form__label text-align-center" style={{width: '28%'}}>預期簽到時間：</label>
                      </div>
                      <div style={{width: '50%'}} >
                        <select value={this.state.startTime} className="u-form__select" 
                          onChange={this.handleStartTimeChange}
                        >
                          <option value="0" disabled>請選擇</option>
                          {
                            timeList
                          }
                        </select>
                      </div>
                    </div>
                  </div>  :''
                }
                            {
                  Number(this.state.jobType) !== 8 && Number(this.state.jobType) !== 9 && Number(this.state.jobType) !== 10? 
                  <div className="row">
                    <div className="col-12 col-pad-12">
                      <div style={{width: '50%', textAlign:'center'}}>
                        <label className="u-form__label text-align-center" style={{width: '28%'}}>預期簽退時間：</label>
                      </div>
                      <div style={{width: '50%'}} >
                        <select value={this.state.endTime} className="u-form__select" 
                          onChange={this.handleEndTimeChange}
                        >
                          <option value="0" disabled>請選擇</option>
                          {
                            timeList
                          }
                        </select>
                        </div>
                    </div>
                  </div> :''
                }

                <div className="u-btn-group right">
                  <button type="button" className="btn btn-md save" onClick={this.handleSaveWorkTime}>儲存</button>
                </div>
              </form>
            </div>
          )}
      </div>
    )
  }
}



export default FillShift